import {
  THEME_PROJECT,
  STORAGE_TYPE
} from "@/assets/common/config/config";

const storage = {};

// 	设置本地存储
storage.setStorage = function (key, value) {
  const name = `LISTINGCHECK_OMS_${key}`;
  switch (STORAGE_TYPE) {
    case "localStorage":
      window.localStorage.setItem(name, value);
      break;
    case "sessionStorage":
      window.sessionStorage.setItem(name, value);
      break;
    default:
      window.localStorage.setItem(name, value);
      break;
  }
}

// 	获取本地存储
storage.getStorage = function (key) {
  const name = `LISTINGCHECK_OMS_${key}`;
  let value = null;
  switch (STORAGE_TYPE) {
    case "localStorage":
      value = window.localStorage.getItem(name);
      break;
    case "sessionStorage":
      value = window.sessionStorage.getItem(name);
      break;
    default:
      value = window.localStorage.getItem(name);
      break;
  }
  return value;
}

// 	移除本地存储
storage.removeStorage = function (key) {
  const name = `LISTINGCHECK_OMS_${key}`;
  switch (STORAGE_TYPE) {
    case "localStorage":
      window.localStorage.removeItem(name);
      break;
    case "sessionStorage":
      window.sessionStorage.removeItem(name);
      break;
    default:
      window.localStorage.removeItem(name);
      break;
  }
}

// 	清空本地存储
storage.clearStorage = function () {
  const me = this;
  //  不清空分销商ID和通过邀请人绑定的销售员ID
  let distributorId = JSON.parse(JSON.stringify(me.getStorage("distributorId")));
  let inviterId = JSON.parse(JSON.stringify(me.getStorage("inviterId")));
  let isActivityTipShow = JSON.parse(JSON.stringify(me.getStorage("isActivityTipShow")));
  let rememberPassword = me.getStorage("rememberPassword");
  let username = me.getStorage("username");
  let password = me.getStorage("password");
  switch (STORAGE_TYPE) {
    // case "localStorage":
    //   window.localStorage.clear();
    //   break;
    case "sessionStorage":
      // window.sessionStorage.clear();
      window.sessionStorage.removeItem('LISTINGCHECK_OMS_access_token')
      window.sessionStorage.removeItem('LISTINGCHECK_OMS_refresh_token')
      window.sessionStorage.removeItem('LISTINGCHECK_OMS_AuthsMenu')
      window.sessionStorage.removeItem('LISTINGCHECK_OMS_Auths')
      window.sessionStorage.removeItem('LISTINGCHECK_OMS_expires_in')
      window.sessionStorage.removeItem('LISTINGCHECK_OMS_access_overtime')
      window.sessionStorage.removeItem('LISTINGCHECK_OMS_companyId')
      window.sessionStorage.removeItem('LISTINGCHECK_OMS_userinfo')
      break;
    default:
      // window.localStorage.clear();
      window.localStorage.removeItem('LISTINGCHECK_OMS_access_token')
      window.localStorage.removeItem('LISTINGCHECK_OMS_refresh_token')
      window.localStorage.removeItem('LISTINGCHECK_OMS_AuthsMenu')
      window.localStorage.removeItem('LISTINGCHECK_OMS_Auths')
      window.localStorage.removeItem('LISTINGCHECK_OMS_expires_in')
      window.localStorage.removeItem('LISTINGCHECK_OMS_access_overtime')
      window.localStorage.removeItem('LISTINGCHECK_OMS_companyId')
      window.localStorage.removeItem('LISTINGCHECK_OMS_userinfo')
      break;
  }
  if (distributorId) {
    me.setStorage("distributorId", distributorId);
  }
  if (inviterId) {
    me.setStorage("inviterId", inviterId);
  }
  if (isActivityTipShow) {
    me.setStorage("isActivityTipShow", isActivityTipShow);
  }
  if (rememberPassword) {
    me.setStorage("username", username);
    me.setStorage("password", password);
    me.setStorage(
      "rememberPassword",
      rememberPassword
    );
  }
}

export default storage;